import { Config, ErrorFlow } from 'olympe';
import { httpRequest, getLogger } from '@olympeio/core';

export function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

/**
 *
 * @param {function(*)} setError // use for throw error
 * @returns token or null
 */
export async function getAzureAccessToken(setError) {
    const logger = getLogger('getAzureAccessToken');
    try {
        // Get access_token
        const host = Config.getParameter('azure.oauth2.host');
        const appId = Config.getParameter('azure.oauth2.appId');
        const clientId = Config.getParameter('azure.oauth2.clientId');
        const clientSecret = Config.getParameter('azure.oauth2.clientSecret');
        if (host && appId && clientId && clientSecret) {
            const tokenAttributes = {
                url: `${host}${appId}/oauth2/v2.0/token`,
                clientId: Config.getParameter('azure.oauth2.clientId'),
                clientSecret,
                grantType: 'client_credentials',
                scope: 'https%3A%2F%2Fgraph.microsoft.com%2F.default',
            };
            const token = await httpRequest(
                'POST',
                tokenAttributes.url,
                JSON.stringify({
                    'Content-Type': 'application/x-www-form-urlencoded',
                }),
                `client_id=${tokenAttributes.clientId}\n` +
                    `&scope=${tokenAttributes.scope}\n` +
                    `&client_secret=${tokenAttributes.clientSecret}\n` +
                    `&grant_type=${tokenAttributes.grantType}`
            ).then((res) => res.json());

            token.expirationTimestamp = Date.now() + token['expires_in'] * 1000;
            return token;
        } else {
            // check null in config
            let key = '';
            if (typeof host !== 'string') {
                key += 'host';
            }
            if (typeof appId !== 'string') {
                key += ', appId';
            }
            if (typeof clientId !== 'string') {
                key += ', clientId';
            }
            if (typeof clientSecret !== 'string') {
                key += ', clientSecret';
            }
            const message = `Fail in get config - one of the following configs may be missing: ${key}`;
            logger.error(message);
            setError(ErrorFlow.create(message, 1));
            return null;
        }
    } catch (err) {
        const message = `Get Token Fail: ${(err || {}).message}`;
        logger.error(message);
        setError(ErrorFlow.create(message, 1));
        return null;
    }
}
